import { Injectable } from '@angular/core';
import {HttpInterceptor2} from "./HttpInterceptor.service";
import {GlobalVariable} from "./global.vars";
@Injectable()
export class DevicesService {
  private Http: HttpInterceptor2;
  private API_URL = GlobalVariable.API_URL;

  constructor (public httpInterceptor: HttpInterceptor2) {
    this.Http = httpInterceptor;
  }

  getDeviceList(searchQuery,limit?,page?){
    let l=10;
    let p= 1;
    if (page) p=page;
    if (limit) l=limit;

     return this.Http.post(this.API_URL+'/device/query?limit='+l+'&page='+p,searchQuery)

  }

}



// WEBPACK FOOTER //
// ./src/services/devices.service.ts